import { isMobileApp } from "@faire/deprecated-retailer-visitor-shared/lib/isMobileApp";
import { getSettingAppMigrationAvailable } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingAppMigrationAvailable";

import { useIsAppInstalled } from "../pageData/useIsAppInstalled";

export const useShowContextualAppDownloadCTAs = () => {
  const isAppInstalled = useIsAppInstalled();
  const showContextualAppDownloadCTAs =
    isAppInstalled === false &&
    !isMobileApp() &&
    getSettingAppMigrationAvailable();

  return { showContextualAppDownloadCTAs };
};
